/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// Get current hostname to determine if it's local or live
const isLocalhost = window.location.hostname === 'localhost'

// Dynamically set the redirect URLs based on the environment
const awsmobile = {
  Auth: {
    identityPoolId: 'eu-west-1:e7333bea-a9ae-465f-8437-fd41c8d74e96', // Your Identity Pool ID
    region: 'eu-west-1', // Your Cognito region
    userPoolId: 'eu-west-1_P1f3QIriC', // Your User Pool ID
    userPoolWebClientId: 'u0gr0t4qerbk1si5isji5pm2s', // Your User Pool Web Client ID
    oauth: {
      domain: 'cv-builder.auth.eu-west-1.amazoncognito.com', // Replace with your Cognito domain
      scope: ['openid', 'profile', 'email'], // Adjust based on your requirements
      redirectSignIn: isLocalhost
        ? 'http://localhost:8080/home' // Localhost callback URL
        : 'https://cv-frontend.d38dh5nhlt7kta.amplifyapp.com/home', // Live callback URL
      redirectSignOut: isLocalhost
        ? 'http://localhost:8080/login' // Localhost logout URL
        : 'https://cv-frontend.d38dh5nhlt7kta.amplifyapp.com/login', // Live logout URL
      responseType: 'code', // or 'token' depending on your flow
    },
  },
  aws_project_region: 'eu-west-1',
}

export default awsmobile
